import React, { FC } from "react";
import { FieldRenderProps } from "react-final-form";
import { InputBaseProps } from "@material-ui/core/InputBase";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { makeStyles, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import Editor from "./Editor";

const Accordion = withStyles({
  root: {
    padding: 0,
    position: "relative",
    backgroundColor: "rgba(0, 0, 0, .01)",
    borderRadius: ".9375rem",
    border: "solid 1px rgba(197,197,197,.3)",
    boxShadow: "none",
    marginTop: 20,
    "&:before": {
      display: "none",
    },
  },
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    cursor: "pointer",
  },
})(MuiAccordionSummary);

const AccordionContent = withStyles(() => ({
  root: {
    display: "block",
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles(() => ({
  error: {
    border: "1px solid #f8202d",
  },
  errorText: {
    color: "#f8202d",
    position: "absolute",
    visibility: "visible",
    bottom: -22,
    right: 0,
    fontSize: 14,
  },
  arrowIcon: {
    transform: "rotate(90deg)",
  },
}));

export const AccordionItem: FC<FieldRenderProps<InputBaseProps>> = ({
  isRequired,
  isExpanded,
  onExpand,
  title,
  input,
  meta: { dirtySinceLastSubmit, invalid, submitError } = {},
}) => {
  const classes = useStyles();

  return (
    <Accordion
      expanded={isExpanded}
      onChange={onExpand()}
      className={invalid && !dirtySinceLastSubmit ? classes.error : ""}
    >
      <AccordionSummary
        expandIcon={<ArrowRightIcon className={classes.arrowIcon} />}
      >
        <Typography>
          {title}
          {isRequired && " *"}
        </Typography>
      </AccordionSummary>
      <AccordionContent>
        {isExpanded && (
          <Editor textData={input.value as string} setData={input.onChange} />
        )}
      </AccordionContent>
      <Typography className={classes.errorText}>
        {invalid && !dirtySinceLastSubmit ? submitError : ""}
      </Typography>
    </Accordion>
  );
};
